module.exports = __webpack_public_path__ + "img/IMG_5528_l.e92af299.jpg";